export default __webpack_public_path__ + "static/media/security-officer.2cc5c32e.svg";